import axios from 'axios';

// function that makes the api request and returns a Promise for response
export const apiRequest = (requestType, url, headers) => {
  return axios({
    method: requestType,
    url,
    headers
  });
};
